(function () {
  'use strict';

  if (window.FloramePrivacy) return;

  var analyticsCallbacks = new Set();
  var analyticsWasAllowed = false;
  var apiChecks = 0;
  var apiTimer = null;
  var featureLoadRequested = false;

  function customerPrivacy() {
    return window.Shopify && window.Shopify.customerPrivacy
      ? window.Shopify.customerPrivacy
      : null;
  }

  function analyticsAllowed() {
    try {
      var api = customerPrivacy();
      return !!(api && typeof api.analyticsProcessingAllowed === 'function'
        && api.analyticsProcessingAllowed() === true);
    } catch (_) {
      return false;
    }
  }

  function preferencesAllowed() {
    try {
      var api = customerPrivacy();
      return !!(api && typeof api.preferencesProcessingAllowed === 'function'
        && api.preferencesProcessingAllowed() === true);
    } catch (_) {
      return false;
    }
  }

  function marketingAllowed() {
    try {
      var api = customerPrivacy();
      return !!(api && typeof api.marketingAllowed === 'function'
        && api.marketingAllowed() === true);
    } catch (_) {
      return false;
    }
  }

  function clearDeclinedIdentifiers() {
    var api = customerPrivacy();
    if (!api || typeof api.currentVisitorConsent !== 'function') return;
    var consent = api.currentVisitorConsent();
    var analyticsDeclined = consent.analytics === 'no';
    var marketingDeclined = consent.marketing === 'no';
    // Only documented, non-essential first-party identifiers. Shopify owns its consent and session cookies.
    if (analyticsDeclined) {
      ['bouquetSessionId', 'florame_rum_session_v1', 'florame_rum_auth_observation_v1'].forEach(function (key) {
        try { localStorage.removeItem(key); sessionStorage.removeItem(key); } catch (_) { }
      });
    }
    var domains = [''];
    var labels = location.hostname.split('.');
    for (var i = 0; i < labels.length - 1; i++) domains.push(labels.slice(i).join('.'));
    document.cookie.split(';').forEach(function (part) {
      var name = part.trim().split('=')[0];
      if (!(analyticsDeclined && /^(_ga(?:_|$)|_gid$|_gat(?:_|$)|_clck$|_clsk$)/.test(name))
        && !(marketingDeclined && /^(_fbp$|_fbc$|_gcl_)/.test(name))) return;
      domains.forEach(function (domain) {
        document.cookie = name + '=; Max-Age=0; Path=/; SameSite=Lax' + (domain ? '; Domain=' + domain : '');
      });
    });
  }
  var cleanupTimers = [];
  function syncDeclinedIdentifiers() {
    cleanupTimers.forEach(function (timer) { window.clearTimeout(timer); });
    clearDeclinedIdentifiers();
    // Pixels already in flight can finish after Shopify emits the change. Recheck the CURRENT choice.
    cleanupTimers = [500, 2000].map(function (delay) { return window.setTimeout(clearDeclinedIdentifiers, delay); });
  }

  function flushAnalyticsCallbacks() {
    if (!analyticsAllowed()) return false;
    if (analyticsWasAllowed) return true;
    analyticsWasAllowed = true;
    analyticsCallbacks.forEach(function (callback) {
      try { callback(); } catch (_) { }
    });
    analyticsCallbacks.clear();
    return true;
  }

  function requestPrivacyApi() {
    if (customerPrivacy() || featureLoadRequested) return;
    try {
      if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        featureLoadRequested = true;
        window.Shopify.loadFeatures(
          [{ name: 'consent-tracking-api', version: '0.1' }],
          function () { retryConsentSync(); }
        );
      }
    } catch (_) {
      featureLoadRequested = false;
    }
  }

  function waitForPrivacyApi() {
    requestPrivacyApi();
    if (customerPrivacy()) clearDeclinedIdentifiers();
    flushAnalyticsCallbacks();
    if (customerPrivacy() || apiChecks >= 40) {
      if (apiTimer) window.clearInterval(apiTimer);
      apiTimer = null;
      return;
    }
    apiChecks += 1;
  }

  function retryConsentSync() {
    apiChecks = 0;
    if (!apiTimer) apiTimer = window.setInterval(waitForPrivacyApi, 250);
    waitForPrivacyApi();
  }

  function onAnalyticsAllowed(callback) {
    if (typeof callback !== 'function') return function () { };
    if (analyticsAllowed()) {
      analyticsWasAllowed = true;
      callback();
      return function () { };
    }
    analyticsCallbacks.add(callback);
    if (!apiTimer) apiTimer = window.setInterval(waitForPrivacyApi, 250);
    return function () { analyticsCallbacks.delete(callback); };
  }

  var preferencesOpener = null;
  function openPreferences(event) {
    preferencesOpener = event && event.currentTarget instanceof HTMLElement ? event.currentTarget : document.activeElement;
    if (event && typeof event.preventDefault === 'function') event.preventDefault();
    try {
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
        window.privacyBanner.showPreferences();
        return true;
      }
    } catch (_) { }
    try {
      var api = customerPrivacy();
      if (api && typeof api.showPreferences === 'function') {
        api.showPreferences();
        return true;
      }
    } catch (_) { }
    var trigger = document.querySelector(
      '#shopify-pc__banner__btn-manage-prefs, [data-shopify-customer-privacy="preferences"], .shopify-pc__prefs__button'
    );
    if (trigger) {
      trigger.click();
      return true;
    }
    return false;
  }

  // Enhance the native nodes once: their handlers and consent state stay owned by Shopify.
  var reviewedPanels = new WeakSet();
  function polishConsentPanel(panel) {
    if (reviewedPanels.has(panel)) return;
    reviewedPanels.add(panel);
    var italian = /^it\b/i.test(document.documentElement.lang || 'it');
    var isPreferences = panel.id === 'shopify-pc__prefs__dialog';
    if (isPreferences) {
      var actions = panel.querySelector('.shopify-pc__prefs__header-actions');
      if (actions) panel.appendChild(actions); // Reading order and keyboard order follow the visual order.
    }
    if (!italian) return;
    function text(selector, value) {
      var node = panel.querySelector(selector);
      if (node) node.textContent = value;
    }
    function policyLinks(node) {
      if (!node) return;
      node.appendChild(document.createTextNode(' '));
      var link = document.createElement('a');
      link.href = '/pages/cookie-policy';
      link.textContent = 'Cookie Policy';
      node.appendChild(link);
      node.appendChild(document.createTextNode(' · '));
      var privacy = document.createElement('a');
      privacy.href = '/pages/privacy-policy';
      privacy.textContent = 'Privacy';
      node.appendChild(privacy);
    }
    if (isPreferences) {
      text('#shopify-pc__prefs__header-title', 'Le tue preferenze cookie');
      text('#shopify-pc__prefs__header-save', 'Salva le preferenze');
      text('#shopify-pc__prefs__header-decline', 'Rifiuta tutti');
      var close = panel.querySelector('#shopify-pc__prefs__header-close');
      if (close) close.setAttribute('aria-label', 'Chiudi senza salvare');
      var intro = panel.querySelector('.shopify-pc__prefs__intro p');
      if (intro) intro.textContent = 'Scegli quali cookie facoltativi consentire. Puoi cambiare idea in ogni momento, anche rifiutandoli tutti.';
      policyLinks(intro);
      text('#shopify-pc__prefs__essential p', 'Sempre attivi. Servono per sicurezza, accesso e carrello: senza, il negozio non potrebbe funzionare.');
    } else {
      text('#shopify-pc__banner__body-title', 'La tua privacy, a tua scelta');
      text('#shopify-pc__banner__btn-accept', 'Accetta tutti');
      text('#shopify-pc__banner__btn-decline', 'Rifiuta tutti');
      text('#shopify-pc__banner__btn-manage-prefs', 'Scegli i cookie');
      var manage = panel.querySelector('#shopify-pc__banner__btn-manage-prefs');
      if (manage && manage.parentNode) manage.parentNode.appendChild(manage);
      var body = panel.querySelector('.shopify-pc__banner__body p');
      if (body) body.textContent = 'Usiamo cookie necessari per far funzionare Florame. Con il tuo consenso, noi e i nostri partner, incluso Shopify, usiamo anche cookie per personalizzare l’esperienza, analizzare le visite e mostrarti pubblicità. Puoi rifiutarli e continuare a fare acquisti.';
      policyLinks(body);
    }
  }
  function containPreferencesKeyboard(event) {
    if (event.key !== 'Tab' && event.key !== 'Escape') return;
    var panel = document.getElementById('shopify-pc__prefs__dialog');
    if (!panel || !panel.getClientRects().length || panel.getAttribute('aria-hidden') === 'true') return;
    if (event.key === 'Escape') {
      var close = panel.querySelector('#shopify-pc__prefs__header-close');
      if (close) { event.preventDefault(); event.stopImmediatePropagation(); close.click(); }
      return;
    }
    var controls = Array.from(panel.querySelectorAll('button, a[href], input, [tabindex]')).filter(function (node) {
      return !node.disabled && node.tabIndex >= 0 && node.getClientRects().length && getComputedStyle(node).visibility !== 'hidden';
    });
    if (!controls.length) return;
    var index = controls.indexOf(document.activeElement);
    var next = index < 0 ? (event.shiftKey ? controls.length - 1 : 0) : (index + (event.shiftKey ? -1 : 1) + controls.length) % controls.length;
    event.preventDefault();
    event.stopImmediatePropagation(); // Shopify cached the old header order before the action footer moved.
    controls[next].focus();
  }
  function startConsentDesign() {
    document.addEventListener('keydown', containPreferencesKeyboard, true);
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest && event.target.closest('#shopify-pc__banner__btn-manage-prefs');
      if (trigger) preferencesOpener = trigger;
    }, true);
    var selector = '#shopify-pc__banner, #shopify-pc__prefs__dialog';
    document.querySelectorAll(selector).forEach(polishConsentPanel);
    new MutationObserver(function (records) {
      records.forEach(function (record) {
        record.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches(selector)) polishConsentPanel(node);
          node.querySelectorAll(selector).forEach(polishConsentPanel);
        });
      });
      if (preferencesOpener && !document.getElementById('shopify-pc__prefs__dialog')) {
        if (preferencesOpener.isConnected) preferencesOpener.focus({ preventScroll: true });
        preferencesOpener = null;
      }
    }).observe(document.body, { childList: true, subtree: true });
    retryConsentSync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startConsentDesign, { once: true });
  else startConsentDesign();

  document.addEventListener('visitorConsentCollected', function () {
    syncDeclinedIdentifiers();
    analyticsWasAllowed = false;
    retryConsentSync();
  });
  document.addEventListener('trackingConsentAccepted', retryConsentSync);

  window.FloramePrivacy = Object.freeze({
    analyticsAllowed: analyticsAllowed,
    preferencesAllowed: preferencesAllowed,
    marketingAllowed: marketingAllowed,
    onAnalyticsAllowed: onAnalyticsAllowed,
    openPreferences: openPreferences
  });
})();
